<template>
  <div class="mt-4">
    <h2 class="text-4xl font-bold tracking-tight mb-6">
      {{ title }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'LocationTitle',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script> 